var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarksSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666667 5c1.3500294 0 2.4444444 1.09441506 2.4444444 2.44444444V27l-8.5555555-3.6666667L7 27V7.44444444C7 6.08777778 8.1 5 9.44444444 5H21.6666667m-7.3333334 13.4444444l7.6388889-7.6266666-1.7233333-1.73555558-5.9155556 5.91555558-3.1655555-3.1655556-1.72333336 1.7233334 4.88888886 4.8888888z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarksSquare);
export default __webpack_public_path__ + "static/media/bookmarks-square.f55e8a105d7459a2a032422e9f5b415c.svg";
export { ForwardRef as ReactComponent };